var map = {
	"./AccessControl.json": [
		78047,
		47
	],
	"./Applications.json": [
		82055,
		55
	],
	"./Ballots.json": [
		39199,
		199
	],
	"./Collaborations.json": [
		23142,
		142
	],
	"./Commitments.json": [
		8054,
		54
	],
	"./Companies.json": [
		15111,
		111
	],
	"./HoursRegister.json": [
		24358,
		358
	],
	"./MemberNotifications.json": [
		36378,
		378
	],
	"./Parameters.json": [
		21876,
		876
	],
	"./Persons.json": [
		36830,
		830
	],
	"./Principles.json": [
		28529,
		529
	],
	"./Proposals.json": [
		73711,
		711
	],
	"./Reports.json": [
		28867,
		867
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 52917;
module.exports = webpackAsyncContext;